import { render } from "./LoginOverlay.vue?vue&type=template&id=400cf1d6&scoped=true"
import script from "./LoginOverlay.vue?vue&type=script&lang=js"
export * from "./LoginOverlay.vue?vue&type=script&lang=js"

import "./LoginOverlay.vue?vue&type=style&index=0&id=400cf1d6&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-400cf1d6"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBtn});
